import { Row, Col, Card } from 'react-bootstrap';
import { FaLinkedin } from 'react-icons/fa';
import Section from '../components/Section';
import Seo from '../components/Seo';

const About = () => {
    return (
        <>
            <Seo
                title="About | Fractional Sales VP for Industrial B2B Companies"
                description="Meet Lutfu Okman, a senior global B2B sales and commercial executive providing fractional sales and commercial leadership."
                jsonLd={{
                    '@context': 'https://schema.org',
                    '@type': 'AboutPage',
                    name: 'About SalesFractionPro',
                    description: 'Background and experience of Lutfu Okman and SalesFractionPro.',
                }}
            />

            <Section className="page-hero" variant="hero">
                <Row>
                    <Col>
                        <h1 style={{ fontSize: 60 }}>About</h1>
                    </Col>
                </Row>
            </Section>

            <Section variant="alt" className="pt-6 pb-5">
                <Row className="align-items-start gy-4">
                    <Col lg={7} className="about-intro">
                        <h6 className="lead">
                            SalesFractionPro provides fractional sales and commercial leadership to industrial B2B companies navigating growth, margin pressure, or transition.
                        </h6>
                        <div>
                            <h2 className='fw-bold'>Meet Lutfu Okman</h2>
                            <h3>Your Fractional Partner in Sales &amp; Commercial Leadership</h3>
                        </div>
                        <hr style={{ borderBottom: '1px solid #e6e6e6' }} />
                        <div>
                            <p>
                                When growth, profitability, and strategic clarity matter, companies benefit from a seasoned commercial leader who has operated at scale, led through complexity, and delivered results across markets, cycles, and ownership structures.
                            </p>
                            <p>
                                I am a global B2B commercial executive with more than 20 years of senior leadership experience, helping industrial and specialty businesses accelerate growth, strengthen execution, and create sustainable enterprise value, with deep expertise in sales leadership, pricing, and commercial execution.
                            </p>
                            <p>
                                My background includes full P&amp;L responsibility, business turnarounds, growth acceleration, and exit preparation-working closely with Boards, founders, and private equity owners.
                            </p>
                            <p>
                                Based in Toronto, I work with clients across North America and Europe, and support select international engagements remotely.
                            </p>
                            <p>What differentiates my approach is perspective and execution.</p>
                            <p>
                                I have led businesses inside global multinationals and PE-backed platforms across Europe, Asia, the Middle East, and North America.
                            </p>
                            <p className='mb-0'>
                                From Board-level strategy to frontline sales execution, I connect the commercial, operational, and people dimensions of the business to drive results.
                            </p>
                        </div>
                    </Col>
                    <Col lg={5}>
                        <div className="about-image-wrap mb-3">
                            <img
                                src="/Lutfu_Okman.jpeg"
                                alt="Lutfu Okman"
                                className="about-image"
                            />
                        </div>
                        <a
                            href="https://www.linkedin.com/in/lutfu-okman-9bbb6526/"
                            target="_blank"
                            rel="noreferrer"
                            className="about-linkedin-inline"
                            style={{ display: 'flex', alignItems: 'center', gap: '0.55rem', textDecoration: 'none' }}
                            aria-label="View Lutfu Okman's LinkedIn profile"
                        >
                            <FaLinkedin aria-hidden="true" size={26} color="#0a66c2" />
                            <h3 className="about-linkedin-name" style={{ margin: 0 }}>Lutfu Okman</h3>
                        </a>
                    </Col>
                </Row>
            </Section>

            <Section className='py-5'>
                <h2>I am Motivated by Solving Complex Commercial Challenges:</h2>
                <Row className='mt-4'>
                    <Col>
                        <ul className='mb-0'>
                            <li>Resetting growth strategy</li>
                            <li>Improving pricing and margin discipline</li>
                            <li>Building high-performing sales organizations</li>
                            <li>Aligning teams around clear priorities and accountability</li>
                        </ul>

                    </Col>
                    <Col>
                        <p className='mb-0'>
                            My leadership style is customer-centric, data-driven, and action-oriented. As a fractional executive, I bring senior judgment and execution capability-without the cost or rigidity of a full-time hire-supporting organizations through growth, transformation, or preparation for a strategic transaction.
                        </p>
                    </Col>
                </Row>
            </Section>

            <Section variant='alt' className='pt-5 pb-6'>
                <Row className="mb-4">
                    <Col>
                        <h2 className='fw-semibold mb-0'>
                            Experience Highlights
                        </h2>
                    </Col>
                </Row>
                <Row className="g-4">
                    <Col md={6}>
                        <Card className="service-card h-100 p-2">
                            <Card.Body>
                                <h4>Industries</h4>
                                <ul className='mb-0'>
                                    <li>Specialty and Performance Chemicals</li>
                                    <li>Building Materials</li>
                                    <li>Paints and Coatings</li>
                                    <li>Textile, Fiber and Leather Chemicals</li>
                                    <li>Paper and Construction Chemicals</li>
                                    <li>Industrial Manufacturing</li>
                                    <li>Tobacco Industry (Filter Solutions)</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card className="service-card h-100 p-2">
                            <Card.Body>
                                <h4>Selected Outcomes</h4>
                                <ul className='mb-0'>
                                    <li>Tripled EBITDA in a global specialty chemicals business and positioned it for divestment</li>
                                    <li>Led global sales and marketing organizations of more than 400 people with revenues up to $800 million</li>
                                    <li>Delivered turnarounds, margin expansion, and commercial excellence programs across multiple regions</li>
                                    <li>Supported M&amp;A, integration, and exit readiness in private equity-backed environments</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Section>
        </>
    );
};

export default About;
